import streamsTest from './stream_test';
import bufferedStreamsTest from './buffered_stream_test';
import arrayStreamTest from './array-stream-test';
import offsetTest from './offset-test';

export default {
    streamsTest,
    bufferedStreamsTest,
    arrayStreamTest,
    offsetTest
}

